import { render } from "./StatusCell.vue?vue&type=template&id=761fc574&scoped=true"
import script from "./StatusCell.vue?vue&type=script&lang=js"
export * from "./StatusCell.vue?vue&type=script&lang=js"

import "./StatusCell.vue?vue&type=style&index=0&id=761fc574&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-761fc574"]])

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip});
